var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.651855,
    y: 0.385742,
    width: 17,
    height: 18.3077,
    rx: 3.92308,
    fill: "#E82222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.304 6.16016L12.9761 11.4636C12.8923 12.8186 12.8505 13.4961 12.5109 13.9833C12.3429 14.2241 12.1267 14.4273 11.876 14.58C11.3689 14.889 10.6901 14.889 9.33244 14.889C7.97308 14.889 7.29339 14.889 6.78592 14.5795C6.53504 14.4265 6.31877 14.2228 6.1509 13.9816C5.81138 13.4938 5.77042 12.8153 5.6885 11.4584L5.36865 6.16016",
    stroke: "white",
    strokeWidth: 0.952237,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57471 6.16016H14.0971M11.4814 6.16016L11.1203 5.41516C10.8804 4.92028 10.7604 4.67283 10.5535 4.51851C10.5077 4.48428 10.4591 4.45383 10.4082 4.42746C10.1791 4.30859 9.90411 4.30859 9.35414 4.30859C8.79037 4.30859 8.5085 4.30859 8.27556 4.43245C8.22394 4.4599 8.17468 4.49158 8.12829 4.52717C7.91898 4.68774 7.80207 4.94424 7.56823 5.45723L7.2478 6.16016",
    stroke: "white",
    strokeWidth: 0.952237,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01367 11.9798V8.80566",
    stroke: "white",
    strokeWidth: 0.952237,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6587 11.9798V8.80566",
    stroke: "white",
    strokeWidth: 0.952237,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete02);
export default __webpack_public_path__ + "static/media/delete-02.a2ae5a36f75b4ff366597c416bc7e02e.svg";
export { ForwardRef as ReactComponent };